import { RoomProvider } from './liveblocks-notes.config'
import { PropsWithChildren } from 'react'

import { Loading } from '@/components/lemmala-design-system/loading/loading'

type NotesProviderProps = {
  roomId: string
  loadingNode?: React.ReactNode
} & PropsWithChildren

export const NotesProvider = ({ roomId, loadingNode, children }: NotesProviderProps) => {
  if (!roomId) return loadingNode || <Loading />
  return (
    <RoomProvider id={roomId} initialPresence={{ cursor: null, color: 'red' }}>
      {children}
    </RoomProvider>
  )
}
